
<router-outlet></router-outlet>

<ng-http-loader 
[backdrop]="true"
[backgroundColor]="'#ff0f80'">
</ng-http-loader>

